import { Actions as o } from "./actions/actions.js";
import { Remove as e } from "./remove/remove.js";
import { Toggle as r } from "./toggle/toggle.js";
import { Trigger as m } from "./trigger.js";
import { Value as t } from "./value/value.js";
import { ComboboxTriggerValueMultiple as i } from "./value-multiple/index.js";
import { ValueMultipleItem as n } from "./value-multiple/value-multiple-item/value-multiple-item.js";
import { ItemIcon as V } from "./value-multiple/value-multiple-item/item-icon/item-icon.js";
import { ItemContent as I } from "./value-multiple/value-multiple-item/item-content/item-content.js";
import { ItemRemove as c } from "./value-multiple/value-multiple-item/item-remove/item-remove.js";
const s = Object.assign(m, {
  ValueMultiple: i,
  Value: t,
  Actions: o,
  Toggle: r,
  Remove: e
});
export {
  s as ComboboxTrigger,
  o as ComboboxTriggerActions,
  e as ComboboxTriggerRemove,
  r as ComboboxTriggerToggle,
  t as ComboboxTriggerValue,
  i as ComboboxTriggerValueMultiple,
  n as ComboboxTriggerValueMultipleItem,
  I as ComboboxTriggerValueMultipleItemContent,
  V as ComboboxTriggerValueMultipleItemIcon,
  c as ComboboxTriggerValueMultipleItemRemove
};
